import { combineReducers } from 'redux'
import templates from './list/reducers'

const gridVariablesReducer = combineReducers({
  templates,
})

export default gridVariablesReducer
